import { render } from "./AiUsage.vue?vue&type=template&id=96390c32"
import script from "./AiUsage.vue?vue&type=script&lang=js"
export * from "./AiUsage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__